<template>
  <div
    v-if="combinationList.length"
    class="combination-list-container"
    :class="{ 'active-combination-list-container': !isSelectMenu }"
  >
    <div class="combination-list-header">
      <div class="combination-button-group">
        <button class="all-select-button" @click="toggleAllListSelect">
          <i
            :class="{
              'ii-check-circle': selectedList.length === combinationList.length,
              'ii-check-circle-outline':
                selectedList.length !== combinationList.length,
            }"
          ></i>
          <span>전체선택</span>
        </button>
        <button class="delete-button" @click="openDeleteModal">
          선택 삭제
        </button>
      </div>
      <span class="combination-list-desc"
        >*중복 조합은 제외하고 표시됩니다.</span
      >
    </div>

    <SearchResultItem
      v-for="(item, idx) in combinationList"
      :key="`${idx}`"
      :selected-list="selectedList"
      :item="item"
      @update-list="updateList"
    />
    <!-- 조합 삭제 모달  -->
    <div v-if="isOpenDeleteModal" class="delete-modal-container">
      <div class="delete-modal-inner-container">
        <h2 class="search-count-title">선택한 청구 조건을 삭제하시겠습니까?</h2>
        <div class="button-group">
          <button class="cancle-button" @click="closeDeleteModal">취소</button>
          <button class="confirm-button" @click="removeList">확인</button>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="empty-basket-list">
    <span> 담은 청구 조합 결과가 없습니다.</span>
    <span> 청구 조합기에서 새로운 조건을 조회해 보세요.</span>
  </div>
</template>

<script>
import SearchResultItem from '@/components/ClaimCombination/SearchResultItem.vue';
import { combinationApi } from '../../services/apis';

export default {
  name: 'claim-combination-bascket',
  components: {
    SearchResultItem,
  },
  props: {
    isSelectMenu: {
      type: Boolean,
      required: true,
    },
    combinationList: {
      type: Array,
      required: true,
    },

    selectedList: {
      type: Array,
      required: true,
    },
    getCombination: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isOpenDeleteModal: false,
    };
  },

  methods: {
    toggleAllListSelect() {
      const isAllListSeleted =
        this.selectedList.length === this.combinationList.length;
      if (isAllListSeleted) {
        this.$emit('update:selected-list', []);
        return;
      }
      this.$emit('update:selected-list', this.combinationList);
    },
    openDeleteModal() {
      if (this.selectedList.length) {
        this.isOpenDeleteModal = true;
      }
    },
    closeDeleteModal() {
      this.isOpenDeleteModal = false;
    },
    async removeList() {
      try {
        const removeList = this.selectedList.map(item => item.id);
        const { status } = await combinationApi.deleteCombination(removeList);
        if (status === 200 || status === 204) {
          this.getCombination();
        }
      } catch (e) {
        console.log(e);
      }
      this.$emit('update:selected-list', []);
      this.closeDeleteModal();
    },

    updateList(curList) {
      // 이미 리스트에 있다면 제거 아니면 추가
      const isExist = this.selectedList.some(item => {
        return item.id === curList.id;
      });
      if (isExist) {
        this.$emit('update:selected-list', [
          ...this.selectedList.filter(item => {
            return item.id !== curList.id;
          }),
        ]);
      } else {
        this.$emit('update:selected-list', [...this.selectedList, curList]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-modal-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  z-index: 11;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);

  .delete-modal-inner-container {
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 24.5rem;
    padding: 1.5rem;
    border-radius: 0.625rem;
    background: #fff;
    & > h2 {
      font-weight: 700;
      font-size: 1.0625rem;
      margin: 1.25rem 0;
    }
    .button-group {
      display: flex;
      align-items: center;
      background-color: blue($color: #000000);
    }
    .cancle-button,
    .confirm-button {
      width: 10.4375rem;
      height: 3.25rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.375rem;
      padding: 1rem 0.875rem;
      font-weight: 700;
    }
    .cancle-button {
      color: #1d77ff;
      border: 0.0625rem solid #d4d7df;
      margin-right: 0.3125rem;
    }
    .confirm-button {
      background: #1d77ff;
      color: #fff;
      border: 0.0625rem solid #1d77ff;
      margin-left: 0.3125rem;
    }
  }
}

.active-combination-list-container {
  width: 51.5rem;
  // width: 62.5rem;
  background-color: #f4f4f4;
  margin-right: 3.75rem;
}
.combination-list-container {
  .combination-list-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.625rem;
    .combination-button-group {
      display: flex;
      align-items: center;
      button {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .all-select-button {
      margin-right: 1.25rem;
      .ii-check-circle {
        font-size: 1.625rem;
        color: #1066e9;
        margin-right: 0.625rem;
      }
      .ii-check-circle-outline {
        font-size: 1.625rem;
        // padding-left: 0.75rem;
        // padding-top: 0.5rem;
        margin-right: 0.625rem;
        color: #d4d7df;
      }
      span {
        font-size: 0.8125rem;
        color: #1a1b1e;
      }
    }
    .delete-button {
      width: 4.875rem;
      height: 2.25rem;
      background-color: #fff;
      border: 0.0625rem solid #e1e4ec;
      border-radius: 0.125rem;
      font-size: 0.8125rem;
      color: #1a1b1e;
    }
    .combination-list-desc {
      font-size: 0.8125rem;
      color: #94969d;
    }
  }
}
.empty-basket-list {
  width: 100%;
  margin-top: 9.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 0.9375rem;
  z-index: 12;
  color: #b5b7bf;
}
</style>
